/* import __COLOCATED_TEMPLATE__ from './created-at-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();